module.exports = __webpack_public_path__ + "img/uz.908abf27.png";